import styled from "@emotion/styled";
import { HeadingTabContainer } from "../../styles";

export const ProfiloClinicoSubtabContainer = styled(HeadingTabContainer)`
    position: static;
`;